import classNames from "classnames";
import Link from 'next/link';
import FilmwebSGLogoSvg from 'src/components/svg/FilmwebSGLogoSvg';
import styles from './StreamingguideLogo.module.css';

//#region [Props]
type StreamingguideLogoProps = {
	className?: string;
};
//#endregion

//#region [Component]
export default function StreamingguideLogo({ className }: StreamingguideLogoProps) {
	return <Link href="/streamingguide" aria-label="Streamingguiden" className={classNames(styles.SLogoContainer, className)}><FilmwebSGLogoSvg /></Link>;
}
//#endregion
